import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler} from "../../helpers/mainHelpers";
import ScrollToTopButton from "../../components/main-buttons/scroll-button/ScrollToTopButton";
import React from "react";
import SupCouncilInfoTree from "./components/supCouncilInfo-tree/SupCouncilInfoTree";
import "./style.less";

const SupCouncilPage = () =>{

  return  <>
    <div className="page_title">
      <PageHeader
        title={
          <div className="page-header_title">
            <div className="page_name">
             Спостережна рада
            </div>
          </div>
        }
        extra={undefined}
        onBack={navigateBackHandler}
      />
    </div>
    <div className="page_content sup-council-page">
      <SupCouncilInfoTree/>
      <ScrollToTopButton elementSelector={".page_content"}/>
    </div>
  </>
}

export default SupCouncilPage
